import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ClientLayout from "../../components/client/ClientLayout";
import { useAuth } from "../../context/AuthContext";
import { clientApi } from "../../api";
import { formatDateAU } from "../../utils/formatDate";

export default function PassesList() {
  const { user } = useAuth();
  const isAdmin = user?.clientRole === "admin";
  const [passes, setPasses] = useState([]);
  const [total, setTotal] = useState(0);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  async function load() {
    setLoading(true); setError("");
    try {
      const d = await clientApi.getPasses(status ? { status } : {});
      setPasses(d.passes || []);
      setTotal(d.total || 0);
    } catch (err) { setError(err.message || "Failed to load passes."); }
    setLoading(false);
  }

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  async function setStatusOnPass(p, newStatus) {
    if (!window.confirm(`Set ${p.first_name || "this pass"} to ${newStatus}?`)) return;
    try { await clientApi.updatePassStatus(p.id, newStatus); await load(); }
    catch (err) { setError(err.message || "Failed to update pass."); }
  }

  return (
    <ClientLayout>
      <div className="venues-page-header">
        <div>
          <h1>Digital Passes</h1>
          <p className="page-subtitle">{total} passes issued across your venue</p>
        </div>
      </div>

      <div style={{ margin: "1rem 0", display: "flex", gap: "0.5rem" }}>
        {["", "ACTIVE", "DEACTIVATED", "VOIDED"].map((s) => (
          <button key={s || "all"} className={`btn btn-sm ${status === s ? "btn-primary" : "btn-outline"}`} aria-pressed={status === s} onClick={() => setStatus(s)}>
            {s || "All"}
          </button>
        ))}
      </div>

      {error && <div className="toast toast-error" style={{ marginBottom: "1rem" }}>{error}</div>}

      {loading ? <div className="loading-state"><div className="spinner" /></div> : passes.length ? (
        <div className="table-wrap">
          <table className="data-table">
            <thead><tr><th>Member</th><th>Member #</th><th>Status</th><th>Issued</th><th><span className="sr-only">Actions</span></th></tr></thead>
            <tbody>
              {passes.map((p) => (
                <tr key={p.id}>
                  <td>{p.first_name} {p.last_name} <div style={{ fontSize: "0.8rem", color: "var(--text-muted)" }}>{p.email}</div></td>
                  <td><Link to={`/client/members/${p.membership_id}`}><code>#{p.membership_id}</code></Link></td>
                  <td><span className={`badge ${p.status === "ACTIVE" ? "active" : p.status === "VOIDED" ? "blocked" : "inactive"}`}>{p.status}</span></td>
                  <td style={{ fontSize: "0.85rem", color: "var(--text-muted)" }}>{formatDateAU(p.created_at)}</td>
                  <td>
                    {isAdmin && p.status === "ACTIVE" && <button className="btn btn-outline btn-sm" onClick={() => setStatusOnPass(p, "DEACTIVATED")}>Deactivate</button>}
                    {isAdmin && p.status !== "ACTIVE" && <button className="btn btn-outline btn-sm" onClick={() => setStatusOnPass(p, "ACTIVE")}>Activate</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="empty-state">
          <h3>No passes yet</h3>
          <p className="muted">Digital passes issued to members will appear here.</p>
        </div>
      )}
    </ClientLayout>
  );
}
